export default __webpack_public_path__ + "static/media/register.98f59692.svg";